import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

/**
 * Palette aligned with rosi.wtf hub (Catppuccin-inspired dark theme).
 * @see https://github.com/catppuccin/palette, tuned to match user's homepage tokens.
 */
const rosiDark = {
  base: '#1e1e2e',
  surface: '#313244',
  mantle: '#181825',
  crust: '#11111b',
  text: '#cdd6f4',
  subtext: '#a6adc8',
  mauve: '#cba6f7',
  lavender: '#b4befe',
  blue: '#8caaee',
  green: '#a6e3a1',
  peach: '#fab387',
  yellow: '#f9e2af',
  red: '#f38ba8',
  pink: '#f5c2e7',
  teal: '#94e2d5'
};

/** Catppuccin Latte: light mode when user toggles in Settings */
const latte = {
  rosewater: '#dc8a78',
  flamingo: '#dd7878',
  pink: '#ea76cb',
  mauve: '#8839ef',
  red: '#d20f39',
  maroon: '#e64553',
  peach: '#fe640b',
  yellow: '#df8e1d',
  green: '#40a02b',
  teal: '#179299',
  sky: '#04a5e5',
  sapphire: '#209fb5',
  blue: '#1e66f5',
  lavender: '#7287fd',
  text: '#4c4f69',
  subtext1: '#5c5f77',
  subtext0: '#6c6f85',
  overlay2: '#7c7f93',
  overlay1: '#8c8fa1',
  overlay0: '#9ca0b0',
  surface2: '#acb0be',
  surface1: '#bcc0cc',
  surface0: '#ccd0da',
  base: '#eff1f5',
  mantle: '#e6e9ef',
  crust: '#dce0e8'
};

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    dark: true,
    themes: {
      dark: {
        primary: rosiDark.mauve,
        secondary: rosiDark.surface,
        accent: rosiDark.lavender,
        error: rosiDark.red,
        info: rosiDark.blue,
        success: rosiDark.green,
        warning: rosiDark.yellow,
        anchor: rosiDark.text,
        background: rosiDark.base,
        surface: rosiDark.surface,
        mantle: rosiDark.mantle,
        crust: rosiDark.crust,
        cardHighlight: rosiDark.lavender
      },
      light: {
        primary: latte.mauve,
        secondary: latte.surface1,
        accent: latte.lavender,
        error: latte.red,
        info: latte.sky,
        success: latte.green,
        warning: latte.yellow,
        anchor: latte.text,
        background: latte.base,
        surface: latte.surface0,
        mantle: latte.mantle,
        crust: latte.crust,
        cardHighlight: latte.green
      }
    }
  }
});
